import React from "react";
import { useTranslation } from "react-i18next";
import { List, ListSeparator } from "@activecollab/components";
import PropTypes from "prop-types";
import { CheckboxOption } from "./CheckboxOption.jsx";
import { Item } from "./Item.jsx";
import { StartMenuBottomOptionsContainer } from "./StartMenuBottomOptionsContainer.jsx";

export const StartMenu = ({
  onItemClick,
  onChange,
  hiddenFromClient,
  important,
  style,
  hideTaskListPicker,
  hideAssigneePicker,
  hideBottomOptions,
  hideFromClients,
  isLoggedUserClient,
  canSeeEstimates,
  showTaskEstimatesToClients,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <List
      className="tw-py-2 focus:tw-outline-none"
      style={style}
      tabIndex={0}
    >
      {!hideTaskListPicker ? (
        <Item
          id="task_list"
          name={t("Task List")}
          onClick={onItemClick}
        />
      ) : null}
      {!hideAssigneePicker ? (
        <Item
          id="assignee"
          name={t("Assignee")}
          onClick={onItemClick}
        />
      ) : null}
      <Item
        id="date"
        name={t("Due Date")}
        onClick={onItemClick}
      />
      <Item
        id="label"
        name={t("Label")}
        onClick={onItemClick}
      />
      {(!isLoggedUserClient && canSeeEstimates) || (isLoggedUserClient && showTaskEstimatesToClients) ? (
        <Item
          id="estimate"
          name={t("Estimate")}
          onClick={onItemClick}
        />
      ) : null}

      <ListSeparator />

      {hideFromClients && !isLoggedUserClient ? (
        <CheckboxOption
          name="is_hidden_from_clients"
          onChange={onChange}
          checked={hiddenFromClient}
        >
          <div className="tw-flex-1 tw-pr-2 tw-truncate">{t("Hidden from clients")}</div>
        </CheckboxOption>
      ) : null}
      <CheckboxOption
        name="is_important"
        onChange={onChange}
        checked={important}
      >
        <div className="tw-flex-1 tw-pr-2 tw-truncate">{t("High priority")}</div>
      </CheckboxOption>

      {!hideBottomOptions ? (
        <>
          <ListSeparator />
          <StartMenuBottomOptionsContainer {...rest} />
        </>
      ) : null}
    </List>
  );
};

StartMenu.propTypes = {
  onItemClick: PropTypes.func,
  onChange: PropTypes.func,
  style: PropTypes.object,
  hiddenFromClient: PropTypes.bool,
  important: PropTypes.bool,
  canSeeEstimates: PropTypes.bool,
  hideTaskListPicker: PropTypes.bool,
  hideBottomOptions: PropTypes.bool,
  hideAssigneePicker: PropTypes.bool,
  showTaskEstimatesToClients: PropTypes.bool,
  hideFromClients: PropTypes.bool,
  isLoggedUserClient: PropTypes.bool,
};

StartMenu.defaultTypes = {
  style: {},
  hiddenFromClient: false,
  important: false,
  hideTaskListPicker: false,
  hideBottomOptions: false,
  hideAssigneePicker: false,
  hideFromClients: false,
  isLoggedUserClient: false,
};
